import Brace from "backbone.brace";
import Radio from "backbone.radio";
import ReportLinkModel from "./report-link";
import _ from "underscore";

const globalChannel = Radio.channel("global");
const reportChannel = Radio.channel("report");

const Model = Brace.Model.extend({
  idAttribute: "route",

  namedAttributes: {
    route: String,
    columns: Array,
    customColumns: [String],
    customColumnsParams: Object,
    customColumnsCreated: Date,
    url: ReportLinkModel,
    updated: Date,
  },

  defaults: {
    route: null,
    columns: [],
    customColumns: [],
    customColumnsParams: null,
    customColumnsCreated: null,
    url: null,
    updated: null,
  },

  getExportUrl() {
    // get current column order
    const columnOrder = reportChannel.request("dt:columnOrder");

    // merge model data, column order, export flag and credentials
    const data = Object.assign(
      {},
      this.getUrl().getData(),
      columnOrder,
      { jsonType: "export" },
      globalChannel.request("auth:credentials")
    );

    // append custom columns when present
    const columns = this.getCustomColumns();
    if (!_.isEmpty(columns)) {
      data.customColumns = columns.join();
    }

    // append data as query string to endpoint
    const url = this.getUrl().getEndpoint();
    const params = $.param(data);

    // sometimes a URL may come with params, so we should
    // make sure to use the correct concat param
    let concat = "?";
    if (url.indexOf(concat) > -1) {
      concat = "&";
    }

    return `${url}${concat}${params}`;
  },
});

export { Model as default };
